<div class="overflow-auto container">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">Usuario que diligencia la encuesta</th>
          <th scope="col">Fecha diligenciamiento</th>
          <th scope="col">Muy insatisfecho</th>
          <th scope="col">Insatisfecho</th>
          <th scope="col">Neutral</th>
          <th scope="col">Satisfecho</th>
          <th scope="col">Muy satisfecho</th>
          <th scope="col">Observaciones/Sugerencias</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let encuesta of dataTable">
          <td>{{encuesta.vcUsuario}}</td>
          <td>{{encuesta.vcFechaDiligenciamiento}}</td>
          <td>{{encuesta.vcValor1}}</td>
          <td>{{encuesta.vcValor2}}</td>
          <td>{{encuesta.vcValor3}}</td>
          <td>{{encuesta.vcValor4}}</td>
          <td>{{encuesta.vcValor5}}</td>
          <td>{{encuesta.txObservacionSugerencias}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <br>

  <div class="d-flex flex-row gap-3" *ngIf="dataTable.length > 0">
    <button class="btn btn-secondary col-2" (click)="onExport()">DESCARGAR</button>

    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onExport()">
        <i class="fa-solid fa-file-excel"></i>
    </button>
</div>